"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addIntersectionFiltersToInsight = exports.reverseAndTrimIntersection = exports.convertIntersectionToFilters = exports.sanitizeTableProperties = exports.modifyBucketsAttributesForDrillDown = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ImplicitDrillDownHelper_1 = require("../../utils/ImplicitDrillDownHelper");
var sdk_ui_pivot_1 = require("@gooddata/sdk-ui-pivot");
function matchesDrillDownTargetAttribute(drillDefinition, attribute) {
    return sdk_model_1.attributeLocalId(attribute) === ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillDefinition);
}
var ENUM_PROPERTIES_TYPE;
(function (ENUM_PROPERTIES_TYPE) {
    ENUM_PROPERTIES_TYPE["CONTROLS"] = "controls";
})(ENUM_PROPERTIES_TYPE || (ENUM_PROPERTIES_TYPE = {}));
function modifyBucketsAttributesForDrillDown(insight, drillDefinition) {
    var removedLeftAttributes = sdk_model_1.insightReduceItems(insight, function (acc, cur) {
        if (sdk_model_1.isAttribute(cur) && matchesDrillDownTargetAttribute(drillDefinition, cur)) {
            return [cur];
        }
        return tslib_1.__spreadArrays(acc, [cur]);
    });
    var replacedDrill = sdk_model_1.insightModifyItems(removedLeftAttributes, function (bucketItem) {
        if (sdk_model_1.isAttribute(bucketItem) && matchesDrillDownTargetAttribute(drillDefinition, bucketItem)) {
            var displayForm_1 = ImplicitDrillDownHelper_1.drillDownDisplayForm(drillDefinition);
            return sdk_model_1.modifyAttribute(bucketItem, function (a) { return a.displayForm(displayForm_1).noAlias(); });
        }
        return bucketItem;
    });
    // remove duplicate attributes
    return sdk_model_1.insightReduceItems(replacedDrill, function (acc, cur) {
        if (sdk_model_1.isAttribute(cur)) {
            var alreadyContainsTarget = acc
                .filter(sdk_model_1.isAttribute)
                .find(function (attr) { return sdk_model_1.areObjRefsEqual(cur.attribute.displayForm, attr.attribute.displayForm); });
            return alreadyContainsTarget ? acc : tslib_1.__spreadArrays(acc, [cur]);
        }
        return tslib_1.__spreadArrays(acc, [cur]);
    });
}
exports.modifyBucketsAttributesForDrillDown = modifyBucketsAttributesForDrillDown;
function removePropertiesForRemovedAttributes(insight) {
    var properties = sdk_model_1.insightProperties(insight);
    if (!properties) {
        return insight;
    }
    var identifiers = sdk_model_1.insightItems(insight).map(function (bucketItem) {
        return sdk_model_1.bucketItemLocalId(bucketItem);
    });
    var result = Object.entries(properties).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        if (key === ENUM_PROPERTIES_TYPE.CONTROLS && value.columnWidths) {
            var columns = value.columnWidths.filter(function (columnWidth) {
                if (sdk_ui_pivot_1.isAttributeColumnWidthItem(columnWidth)) {
                    return identifiers.includes(columnWidth.attributeColumnWidthItem.attributeIdentifier);
                }
                return true;
            });
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_b = {}, _b[key] = {
                columnWidths: columns,
            }, _b));
        }
        return tslib_1.__assign({}, acc);
    }, properties);
    return sdk_model_1.insightSetProperties(insight, result);
}
function sanitizeTableProperties(insight) {
    return removePropertiesForRemovedAttributes(insight);
}
exports.sanitizeTableProperties = sanitizeTableProperties;
function convertIntersectionToFilters(intersections) {
    return intersections
        .map(function (intersection) { return intersection.header; })
        .filter(sdk_ui_1.isDrillIntersectionAttributeItem)
        .map(function (header) {
        return sdk_model_1.newPositiveAttributeFilter(header.attributeHeader.ref, {
            uris: [header.attributeHeaderItem.uri],
        });
    });
}
exports.convertIntersectionToFilters = convertIntersectionToFilters;
function reverseAndTrimIntersection(drillConfig, intersection) {
    if (!intersection || intersection.length === 0) {
        return intersection;
    }
    var clicked = ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillConfig);
    var reorderedIntersection = intersection.slice().reverse();
    return sdk_ui_1.getIntersectionPartAfter(reorderedIntersection, clicked);
}
exports.reverseAndTrimIntersection = reverseAndTrimIntersection;
/**
 * @internal
 */
function addIntersectionFiltersToInsight(source, intersection) {
    var filters = convertIntersectionToFilters(intersection);
    var resultFilters = tslib_1.__spreadArrays(source.insight.filters, filters);
    return sdk_model_1.insightSetFilters(source, resultFilters);
}
exports.addIntersectionFiltersToInsight = addIntersectionFiltersToInsight;
//# sourceMappingURL=drillDownUtil.js.map